import printableString from 'printable-string';

export const cleanForCuro = (str: unknown, allowLineBreaks = false) => {
  if (typeof str === 'string') {
    let newStr = str.replaceAll('£', 'GBP ').replace(/[^\x00-\x7F]/g, '');

    if (!allowLineBreaks) {
      newStr = newStr.replace(/(\r\n|\n|\r)/gm, '');
    }

    // Remove escaped sequences like \xNN, \uNNNN, \n, \r, \t, etc.
    newStr = newStr.replace(/\\[nrtbfv0'"\\]/g, ''); // basic escapes
    newStr = newStr.replace(/\\x[0-9A-Fa-f]{2}/g, ''); // hex escaped chars
    newStr = newStr.replace(/\\u[0-9A-Fa-f]{4}/g, ''); // unicode escaped chars
    newStr = newStr.replace(/\\U[0-9A-Fa-f]{8}/g, ''); // 8-digit unicode (rare)

    return printableString(newStr);
  }
  return str;
};
